import { InputForm } from '@/components/new/form/InputForm'
import { TextAreaForm } from '@/components/new'
import { useModalWizardStepsContext } from '@/components/new/modalWizardSteps/ModalWizardStepsContext'
import { AsyncSelectForm } from '@/components/forms/AsyncSelectForm'
import { getCountries } from '@/api/countriesAPI'
import { getContainerCategories } from '@/api/containerCategoriesAPI'
import useContainerWizzardSteps from '@/state/useContainerWizzardSteps'
import { useEffect } from 'react'
import { SelectFormOriginDestiny } from '../../../components/SelectFormOriginDestiny'

export default function DetailsGeneralContainerTab() {
  const { useFormWizzard } = useModalWizardStepsContext()
  const { control, watch, getValues } = useFormWizzard
  const updateData = useContainerWizzardSteps((state) => state.updateData)

  // Sincroniza los valores del formulario con el store global
  useEffect(() => {
    const subscription = watch(() => {
      updateData({
        ...useContainerWizzardSteps.getState().data,
        ...getValues(),
      })
    })
    return () => subscription.unsubscribe()
  }, [watch, getValues, updateData])

  // Async fetchers
  const fetchCountries = async (search: string) => {
    const response = await getCountries()
    if (!Array.isArray(response)) return []
    return response
      .filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))
      .map(({ id, name }) => ({ id: String(id), label: name }))
  }
  const fetchCategories = async (search: string) => {
    const response = await getContainerCategories()
    if (!Array.isArray(response)) return []
    return response
      .filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))
      .map(({ id, name }) => ({ id: String(id), label: name }))
  }

  return (
    <div className={'h-[60dvh] overflow-y-auto'}>
      <div className={'space-y-5 p-4'}>
        <InputForm
          name="name"
          label="Nombre"
          placeholder="Nombre del contenedor"
          control={control}
          rules={{ required: 'Campo requerido' }}
        />
        <SelectFormOriginDestiny
          name="originId"
          control={control}
          label="Origen"
          placeholder="Buscar origen..."
          notFoundMessage="No se encontraron orígenes."
        />
        <AsyncSelectForm
          name="countryFromId"
          control={control}
          label="País de origen"
          fetcher={fetchCountries}
          placeholder="Buscar país..."
          notFoundMessage="No se encontraron países."
        />
        <SelectFormOriginDestiny
          name="destinyId"
          control={control}
          label="Destino"
          placeholder="Buscar destino..."
          notFoundMessage="No se encontraron destinos."
        />
        <AsyncSelectForm
          name="categories"
          control={control}
          label="Categorías"
          fetcher={fetchCategories}
          placeholder="Buscar categorías..."
          notFoundMessage="No se encontraron categorías."
          multiple={true}
        />
        <InputForm
          name="levanteNumber"
          label="Número de levante"
          placeholder="Número de levante"
          control={control}
        />
        <InputForm
          name="trackingNumber"
          label="Número de tracking"
          placeholder="Número de tracking"
          control={control}
        />
        <TextAreaForm
          name="observations"
          label="Observaciones"
          placeholder="Observaciones"
          control={control}
        />
      </div>
    </div>
  )
} 